// This file was automatically generated from admin.clientapps.soy.
// Please don't edit this file by hand.

if (typeof Nightloop == 'undefined') { var Nightloop = {}; }
if (typeof Nightloop.Templates == 'undefined') { Nightloop.Templates = {}; }
if (typeof Nightloop.Templates.Admin == 'undefined') { Nightloop.Templates.Admin = {}; }


Nightloop.Templates.Admin.ClientApps = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  Nightloop.Templates.Admin.Layout(soy.$$augmentData(opt_data, {is_sevenrooms_admin: opt_data.content.is_sevenrooms_admin, DynamicTemplate: 'Nightloop.Templates.Admin.ClientAppsBit'}), output);
  return opt_sb ? '' : output.toString();
};


Nightloop.Templates.Admin.ClientAppsBit = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  Nightloop.Base.ScriptWithIntegrity({type: 'text/javascript', src: opt_data.settings.CACHE_MAP['app/commons.js'].src, integrity: opt_data.settings.CACHE_MAP['app/commons.js'].integrity, skip_integrity: opt_data.settings.SKIP_INTEGRITY, crossorigin: 'anonymous'}, output);
  Nightloop.Base.ScriptWithIntegrity({type: 'text/javascript', src: opt_data.settings.CACHE_MAP['app/core.js'].src, integrity: opt_data.settings.CACHE_MAP['app/core.js'].integrity, skip_integrity: opt_data.settings.SKIP_INTEGRITY, crossorigin: 'anonymous'}, output);
  output.append('<script type="text/javascript">let map = ', soy.$$escapeHtml(opt_data.settings.CACHE_MAP), '<\/script>');
  Nightloop.Base.ScriptWithIntegrity({type: 'text/javascript', src: opt_data.settings.CACHE_MAP['app/admin.js'].src, integrity: opt_data.settings.CACHE_MAP['app/admin.js'].integrity, skip_integrity: opt_data.settings.SKIP_INTEGRITY, crossorigin: 'anonymous'}, output);
  output.append('<div id="api-audience-manager"></div><script>window.SvrManager.ApiAudienceManager.render(\'api-audience-manager\', ', (opt_data.content.can_edit_client_apps) ? 'true' : 'false', ')<\/script>');
  return opt_sb ? '' : output.toString();
};
